/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SuggestOtRequest } from '../../models/suggest-ot-request';
import { SuggestOtResponse } from '../../models/suggest-ot-response';

export interface SuggestOt$Params {
  body: SuggestOtRequest;
}

export function suggestOt(
  http: HttpClient,
  rootUrl: string,
  params: SuggestOt$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<SuggestOtResponse>> {
  const rb = new RequestBuilder(rootUrl, suggestOt.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SuggestOtResponse>;
    })
  );
}

suggestOt.PATH = '/v2/ots/suggestions';
